/* ResponseTable.ts */

export enum ResponseTableStrings {
  OVERALL_RESPONSE_RATE = "Overall Response Rate (ORR)",
  COMPLETE_RESPONSE = "Complete Response",
  PARTIAL_RESPONSE = "Partial Response",
  PROGRESSIVE_DISEASE = "Progressive Disease",
  STABLE_DISEASE = "Stable Disease",
  UNKNOWN = "Unknown",
  ONGOING = "Ongoing",
}
